<template>
  <div class="wrapper">
    <button class="back-btn" type="button" @click.prevent="close">
      <span class="a11y-hidden">뒤로가기</span>
      <arrow-left :color="tonal.white.white" />
    </button>

    <h2 class="title" :style="{ color: tonal?.white.white }">
      {{ props.title }}
    </h2>

    <w-select
      v-if="hasSubCategoryFilter"
      v-model="selectedValue"
      :options="props.options.itemList"
      :placeholder="props.options._default"
      @selected="handleSelected"
    />
  </div>
</template>

<script setup>
  import {
    onMounted,
    ref,
    watch,
    computed,
    defineProps,
    defineEmits,
  } from 'vue'
  import { useRouter } from 'vue-router/composables'
  import { updateRouteUrl } from '@/common/util/shared'
  import { tonal } from '@/constants/tonal'

  import { ArrowLeft } from '@/components/Icons'
  import WSelect from '@/components/ui/Select'

  const router = useRouter()

  const props = defineProps({
    title: {
      type: String,
      default: '',
    },
    options: {
      type: Object,
      default: null,
    },
    closeFn: {
      type: Function,
    },
  })
  const emit = defineEmits(['selectedGenre'])

  const selectedValue = ref(null)

  const hasSubCategoryFilter = computed(
    () => (props.options.itemList?.length ?? 0) > 0,
  )

  watch(selectedValue, () => {
    const { ...currentQuerys } = router.currentRoute.query
    const updateQuery = Object.assign(currentQuerys, {
      subCode: selectedValue.value.value,
    })
    const beforeFullPath = router.currentRoute.fullPath
    const url = updateRouteUrl(beforeFullPath, updateQuery)
    if (beforeFullPath !== url) {
      router.push(url)
    }
  })

  const handleSelected = (event) => {
    if (event.option) {
      selectedValue.value = event.option

      const { value } = selectedValue.value
      emit('updateSubCategory', { subCode: value, eventlist: event.option?.eventlist })
    }
  }

  const close = () => {
    props.closeFn()
  }

  onMounted(() => {
    const selectedGenre = props.options._default

    const foundItem = props.options.itemList.find(
      (item) => item.title === selectedGenre,
    )

    selectedValue.value = foundItem
  })
</script>

<script>
  export default {
    name: 'SubCategoryMenu',
  }
</script>

<style lang="scss" scoped>
  .wrapper {
    display: flex;
    width: 100%;
    align-items: center;
    gap: 16px;
    position: sticky;
    top: 0;
    z-index: 1000;
    background-color: rgb(27, 27, 27);
    max-width: 1240px;
  }

  .back-btn {
    font-size: 0;
    padding: 16px 0 16px 16px;
  }

  .title {
    display: block;
    font-size: 16px;
    line-height: 24px;

    flex: 0 0 auto;
  }
</style>
